import { render, staticRenderFns } from "./hqnotice-add-or-update.vue?vue&type=template&id=4bea5d8b&scoped=true&"
import script from "./hqnotice-add-or-update.vue?vue&type=script&lang=js&"
export * from "./hqnotice-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./hqnotice-add-or-update.vue?vue&type=style&index=0&id=4bea5d8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea5d8b",
  null
  
)

export default component.exports